import React, { Component } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';

import NotebookViews from './views';


class Notebook extends Component {
  render() {
    const { isMobile, isShown, highlights, toggle } = this.props;

    if (!isShown) {
      return null;
    }

    const viewProps = {
      isMobile,
      styles: {
        height: `${window.innerHeight - 54}px`
      },
      highlights,
      toggle
    };

    return <NotebookViews { ...viewProps } />;
  }
}

Notebook.propTypes = {
  isMobile: bool.isRequired,
  isShown: bool.isRequired
};

function mapStateToProp(state) {
  const { reader: { isMobile }, highlights } = state;

  return {
    highlights,
    isMobile
  };
}


export default connect(mapStateToProp)(Notebook);
